import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'

export const newClientsXS = [
    {
        dataField: 'xs',
        text: 'Nuevos Clientes',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Sede:' value={row.storeName} />
                    <TableRowField label='Cantidad de Nuevos Clientes:' value={row.new} />
                </div>
            )
        }
    }
]

export const newClientsSM = [
    {
        dataField: 'storeName',
        text: 'Sede'
    },
    {
        dataField: 'new',
        text: 'Cantidad de Nuevos Clientes'
    },
]

export const newClients = [
    {
        dataField: 'storeName',
        text: 'Sede'
    },
    {
        dataField: 'new',
        text: 'Cantidad de Nuevos Clientes'
    },
]


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardNewClients/_columns.js